import * as PIXI from 'pixi.js'
import * as CSS from 'utils/css.js'
import * as Utils from 'utils/math.js'
import TweenMax from 'gsap'
import Detector from 'utils/Detector'
import MaskFilter from 'filters/Mask/MaskFilter'

export default class HomeFooter {
  constructor (opts) {
    this.size = opts.size
    this.offsetHeight = 0
    this.startTop = 0
    this.prefix = CSS.getPrefix()
    this.isHidden = true
    this.isReady = false

    // console.log(CSS.getMatrixTransform(100, 20, 2, 30))

    this.isMobile = Detector.isMobile()

    this.scrollY = {
      dest: 0,
      current: 0
    }

    this.dom = {
      footerSection: document.querySelector('.home-footer'),
      footerContainer: document.querySelector('.home-footer .home-footer__container')
    }

    this.bounds = {
      footerSection: null,
      footerContainer: null
    }

    this.oldPosition = 0

    this.motions = {
      easePlantLeft: 0,
      easePlantRight: 0,
      rotationPlantLeft: 0,
      rotationPlantRight: 0,
      maxRotationPlantLeft: -20,
      maxRotationPlantRight: 15,
      maxTitleOpacity: 1,
      minTitleOpacity: 0.2,
      minCTAOpacity: 0,
      maxCTAOpacity: 1,
      maxTitleScale: 1,
      minTitleScale: 0.85,
      titleOpacity: 0,
      titleScale: 0,
      ctaOpacity: 1
    }
  }

  getBounds () {
    this.bounds.footerContainer = CSS.getSize(this.dom.footerContainer)
    this.bounds.footerContainer.top = this.startTop
  }

  positionDom () {
    // 6230
    // 5657
    // 573
    // console.log((this.startTop) * 0.1)
    this.dom.footerContainer.style.top = `${this.startTop}px`
  }

  showDom () {
    if (!this.isHidden) return

    this.isHidden = false
    this.dom.footerSection.classList.remove('is-hidden')
  }

  hideDom () {
    if (this.isHidden) return

    this.isHidden = true
    this.dom.footerSection.classList.add('is-hidden')
  }

  update ({time, scrollY}) {
    this.scrollY = scrollY

    // this.scrollY.current = this.scrollY.current

    let limitIn = (this.bounds.footerContainer.top - this.size.h)
    let limitOutVp = limitIn + this.bounds.footerContainer.height + this.size.h

    let vp = this.scrollY.current >= limitIn && this.scrollY.current <= limitOutVp
    if (vp) {
      this.showDom()
      if (this.oldPosition !== -this.scrollY.current) {
        this.oldPosition = -this.scrollY.current
        this.dom.footerSection.style[this.prefix] = CSS.getMatrixTransform(0, (this.oldPosition))
      }
    } else {
      if (this.oldPosition !== -limitOutVp) {
        this.oldPosition = -limitOutVp
        this.dom.footerSection.style[this.prefix] = CSS.getMatrixTransform(0, this.oldPosition)
      }

      // this.hideDom()
    }
  }

  resize (size, startTop) {
    this.size = size
    this.startTop = startTop

    this.getBounds()
    this.positionDom()

    this.offsetHeight = this.bounds.footerContainer.height
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Home/classes/HomeFooter.js
 **/